import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=29f96988"
import script from "./Secure.vue?vue&type=script&lang=js"
export * from "./Secure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports